import { apiPaths } from '../config/api-paths.js';
import request from '../utils/request.js';
import { stringifyQuery } from '../utils/query.js';
import type {
  ActiveUserDateRow,
  ActiveUserSchoolRow,
  ApiResponse,
  CourseDateRow,
  CourseSchoolRow,
  RequestResult,
  StatisticsSearchRequest,
} from '../types/domain.js';

export async function getActiveUserNumberByRange(
  params: StatisticsSearchRequest,
): Promise<RequestResult<ApiResponse<ActiveUserSchoolRow[]>>> {
  return request<ApiResponse<ActiveUserSchoolRow[]>>(
    `${apiPaths.activeUserNumberByRange}?${stringifyQuery(params)}`,
  );
}

export async function getUserActiveNumByDate(
  params: StatisticsSearchRequest,
): Promise<RequestResult<ApiResponse<ActiveUserDateRow[]>>> {
  return request<ApiResponse<ActiveUserDateRow[]>>(
    `${apiPaths.activeUserNumberByDate}?${stringifyQuery(params)}`,
  );
}

export async function getCourseStatisticsBySchool(
  params: StatisticsSearchRequest,
): Promise<RequestResult<ApiResponse<CourseSchoolRow[]>>> {
  return request<ApiResponse<CourseSchoolRow[]>>(
    `${apiPaths.courseStatisticsBySchool}?${stringifyQuery(params)}`,
  );
}

export async function getCourseStatisticsByDate(
  params: StatisticsSearchRequest,
): Promise<RequestResult<ApiResponse<CourseDateRow[]>>> {
  return request<ApiResponse<CourseDateRow[]>>(
    `${apiPaths.courseStatisticsByDate}?${stringifyQuery(params)}`,
  );
}
